<template>
    <v-container fluid grid-list-sm fill-height pa-1>
        <v-layout row wrap>
            <!-- <v-flex d-flex style="max-width:500px;">
                <v-card color="primary lighten-2" dark tile flat>
                    <div class="test">
                        <div v-for="item in files" :key="item.title" class="pa-5 b-b">
                            {{ item.title }}
                        </div>
                    </div>
                </v-card>
            </v-flex> -->
            <v-flex d-flex style="max-width:500px;">
                <v-card tile flat>
                    <div class="file-box">
                        <v-toolbar color="primary" dark>
                            <v-toolbar-title>Content</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon><v-icon>search</v-icon></v-btn>
                            <v-menu>
                                <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
                                <v-list>
                                    <v-list-tile v-for="(item, i) in menuItems" :key="i" @click="onMenu(item.key)">
                                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                        </v-toolbar>

                        <v-list two-line subheader>
                            <v-breadcrumbs divider="/" class="pa-1">
                                <v-breadcrumbs-item v-for="item in breadItems" :key="item.ContentId" @click.native="onBreadClick(item)">
                                    {{ item.ContentName }}
                                </v-breadcrumbs-item>
                            </v-breadcrumbs>
                            <!-- <v-btn fab dark small absolute right color="primary">
                                <v-icon dark>add</v-icon>
                            </v-btn> -->
                            <v-subheader inset>Folders</v-subheader>

                            <v-list-tile v-for="item in folders" :key="item.ContentId" avatar @click="onFolderClick(item)">
                                <v-list-tile-avatar>
                                    <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
                                </v-list-tile-avatar>

                                <v-list-tile-content>
                                    <v-list-tile-title>{{ item.ContentName }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ item.CreatedDate }}</v-list-tile-sub-title>
                                </v-list-tile-content>

                                <v-list-tile v-if="item.icon !== 'more_horiz'">
                                    <v-chip outline color="info lighten-1">{{ item.fileCount }}</v-chip>
                                </v-list-tile>
                                <v-list-tile-action v-if="item.icon !== 'more_horiz'">
                                    <v-btn icon ripple>
                                        <v-icon color="grey lighten-1">more_vert</v-icon>
                                    </v-btn>
                                </v-list-tile-action>
                            </v-list-tile>

                            <v-divider inset></v-divider>
                            <!-- <v-btn fab dark small absolute right color="primary">
                                <v-icon dark>add</v-icon>
                            </v-btn> -->
                            <v-subheader inset>Files</v-subheader>

                            <v-subheader inset v-if="files.length === 0">[No files under this folder]</v-subheader>
                            <v-list-tile v-for="item in files" :key="item.ContentId" avatar @click="onFileClick(item)">
                                <v-list-tile-avatar>
                                    <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
                                </v-list-tile-avatar>

                                <v-list-tile-content>
                                    <v-list-tile-title>{{ item.ContentName }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ item.CreatedDate }}</v-list-tile-sub-title>
                                </v-list-tile-content>

                                <v-list-tile-action>
                                    <v-btn icon ripple>
                                        <v-icon color="grey lighten-1">more_vert</v-icon>
                                    </v-btn>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                    </div>
                </v-card>
            </v-flex>
            <v-flex d-flex>
                <v-card color="blue-grey lighten-5" tile flat>
                    <v-layout align-center justify-center column fill-height v-if="!selectedFile">
                        <div class="text-md-center display-3">Document View</div><br/>
                        <div class="text-md-center headline">Select a document to view it</div>
                    </v-layout>
                    <v-layout column fill-height v-if="selectedFile">
                        <v-card tile flat class="cmt">
                            <v-toolbar color="blue-grey" dark>
                                <v-toolbar-title>{{ selectedFile.ContentName }}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <!-- <v-tooltip bottom>
                                    <v-btn icon slot="activator"><v-icon>save_alt</v-icon></v-btn>
                                    <span>Download</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <v-btn icon slot="activator"><v-icon>mail_outline</v-icon></v-btn>
                                    <span>Email</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <v-btn icon slot="activator"><v-icon>print</v-icon></v-btn>
                                    <span>Print</span>
                                </v-tooltip> -->
                            </v-toolbar>
                            <vue-friendly-iframe id="docFrame" :src="selectedFilePath" className="document-box" />
                        </v-card>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import VueFriendlyIframe from 'vue-friendly-iframe';
import data from '../../assets/data/content.json';

export default {
    name: 'Dashboard',
    components: {
        'vue-friendly-iframe': VueFriendlyIframe
    },
    data() {
        return {
            title: 'Dashboard',
            serverPath: '',
            selectedFolder: '-1',
            selectedFolderParent: '-1',
            selectedFile: null,
            selectedFilePath: 'http://fireflex.co.za',
            breadItems: [],
            sourceData: [],
            breadRoot: { ContentId: '-1', ContentName: 'Home' },
            folders: [
                /* { icon: 'more_horiz', iconClass: 'amber lighten-1 white--text', title: '[Parent Folder]', subtitle: 'Go back up to the parent folder' },
                { icon: 'folder', iconClass: 'amber lighten-1 white--text', title: 'Photos', subtitle: 'Jan 9, 2014', fileCount: 4 },
                { icon: 'folder', iconClass: 'amber lighten-1 white--text', title: 'Recipes', subtitle: 'Jan 17, 2014', fileCount: 12 },
                { icon: 'folder', iconClass: 'amber lighten-1 white--text', title: 'Work', subtitle: 'Jan 28, 2014', fileCount: 0 } */
            ],
            files: [
                /* { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary', subtitle: 'Jan 20, 2014' },
                { icon: 'description', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary2', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel2', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary3', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel3', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary4', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel4', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary5', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel5', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary6', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel6', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary7', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel7', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary8', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel8', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary9', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel9', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary10', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel10', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary11', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel11', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary12', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel12', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary13', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel13', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary14', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel14', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary15', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel15', subtitle: 'Jan 10, 2014' },
                { icon: 'assignment', iconClass: 'light-blue darken-1 white--text', title: 'Vacation itinerary16', subtitle: 'Jan 20, 2014' },
                { icon: 'call_to_action', iconClass: 'light-blue darken-1 white--text', title: 'Kitchen remodel16', subtitle: 'Jan 10, 2014' } */
            ],
            menuItems: [
                { key: 'NEW_FILE', title: 'Add New File' },
                { key: 'NEW_FOLDER', title: 'Add New Folder' },
                { key: 'DELETE', title: 'Delete Selected' },
                { key: 'SETUP', title: 'Setup' }
            ]
        };
    },
    mounted() {
        this.serverPath = `${this.CONST.SERVER_ROOT}/content/`;
        this.loadData();
    },
    methods: {
        loadData() {
            /* this.$http.get('./assets/data/content.json').then(response => {
                console.log(response.data);
            }); */
            this.sourceData = data.RECORDS;
            this.sourceData.forEach(o => {
                if (o.IsFile === '1') {
                    o.icon = 'description';
                    o.iconClass = 'light-blue darken-1 white--text';
                }
                else {
                    o.icon = 'folder';
                    o.iconClass = 'amber lighten-1 white--text';
                    o.fileCount = this.sourceData.reduce((accumulator, item) => accumulator + (item.ParentContentId === o.ContentId), 0);
                }
                o.title = o.ContentName;
                o.subtitle = o.CreatedDate;
            });
            this.breadItems.push(this.breadRoot);
            this.loadDataForSelected();
        },
        loadDataForSelected() {
            this.files = [];
            this.folders = [];
            if (this.selectedFolder !== '-1') {
                this.folders.push({ icon: 'more_horiz', iconClass: 'amber lighten-1 white--text', ContentId: this.selectedFolderParent, ParentContentId: this.selectedFolderParent, ContentName: '[Parent Folder]', ContentPath: '', IsFile: '0', CreatedDate: 'Go back up to the parent folder' });
            }
            this.sourceData.forEach(o => {
                if (o.ParentContentId === this.selectedFolder) {
                    if (o.IsFile === '1') {
                        this.files.push(o);
                    }
                    else {
                        this.folders.push(o);
                    }
                }
            });
        },
        onBreadClick(item) {
            const pos = this.breadItems.indexOf(item);
            this.breadItems.splice(pos + 1, this.breadItems.length - pos);
            this.selectedFolder = item.ContentId;
            this.selectedFolderParent = item.ParentContentId;
            this.loadDataForSelected();
        },
        onFolderClick(item) {
            if (item.ContentName === '[Parent Folder]') {
                item = this.sourceData.find(o => o.ContentId === item.ContentId);
                this.breadItems.pop();
                if (!item) {
                    item = { ContentId: '-1', ParentContentId: null };
                }
            }
            else {
                this.breadItems.push(item);
            }
            this.selectedFolder = item.ContentId;
            this.selectedFolderParent = item.ParentContentId;
            this.loadDataForSelected();
        },
        onFileClick(item) {
            this.selectedFile = item;
            this.selectedFilePath = `${this.serverPath}${item.ContentPath}`;
            this.$nextTick(() => {
                const docFrame = document.querySelectorAll('#docFrame iframe')[0];
                docFrame.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-popups allow-forms');
            });
        },
        onMenu(key) {
            switch (key) {
                default: break;
            }
        }
    }
};
</script>

<style scoped>
.cmt {
    margin-top: 2px;
    height: 100%;
}
.cmt .vue-friendly-iframe {
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Document/Document.vue